import { render, staticRenderFns } from "./AdminEditCamera.vue?vue&type=template&id=1ce39074"
import script from "./AdminEditCamera.vue?vue&type=script&lang=js"
export * from "./AdminEditCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports